<template>
  <section class="d-flex flex-column h-full">
    <div class="flex-grow-1 scroll-y">
      <List></List>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>
  
  <script>
/**
 * Notice 메인 컴포넌트
 *
 * @author jaehyub.lee@emcast.com
 */
import List from "@/components/notice/List";

export default {
  name: "Notice",
  components: {
    List,
  },
};
</script>
  